// extracted by mini-css-extract-plugin
export var active = "_ea-7";
export var blink = "_ea-8";
export var dropDownSelector = "_ea-4";
export var dropDownWrapper = "_ea-3";
export var fakeCursor = "_ea-6";
export var fontSizeButton = "_ea-9";
export var formQuillEditor = "_ea-0";
export var pressed = "_ea-a";
export var qlBlank = "_ea-1";
export var textFormattingToolbar = "_ea-2";
export var textToolbarOption = "_ea-5";